import { SyncActionFactory } from '../../../../shared/utils/redux/sync.actions'
import { FeatureToggleState } from './state'

export class FeatureToggleActions {
  public static setFeatureToggles = new SyncActionFactory<FeatureToggleState>(
    '[FEATURE TOGGLE] SET FEATURE TOGGLES',
  )
}
